import { tasksTableDisplay } from "../../../../config/taskConfigs";



let columnsRenderFunctions = {};
tasksTableDisplay.forEach(item => {
    columnsRenderFunctions[item] = require('./useRenderFilters').default;
})
export default columnsRenderFunctions;